<template>
  <div class="panel panel-default panel-dashboard">
    <div class="panel-heading">
      <div class="row">
        <div class="col-xs-13">
          <h5>
            Channel Type Month-By-Month Development
          </h5>
        </div>

        <div class="col-xs-2">
          <button type="button" class="btn btn-black btn-sm" @click="expanded = !expanded">
            <i class="fa fa-search"/> {{ expanded ? 'Collapse' : 'Expand' }}
          </button>
        </div>

        <div class="col-xs-3">
          <SelectWidget
              v-model="granularity"
              class="form-control input-sm"
              :options="[{value: 'months', label: 'Months'}, {value: 'quarters', label: 'Quarters'}, {value: 'years', label: 'Years'}]"
          />
        </div>

        <div class="col-xs-3">
          <SelectWidget
              v-if="!loading"
              v-model="dataset"
              class="form-control input-sm"
              :nullable="true"
              placeholder="(all datasets)"
              :options="data.datasets.map(dataset => ({value: dataset.id, label: dataset.name}))"
          />
        </div>

        <div class="col-xs-3">
          <SelectWidget
              v-if="!loading"
              v-model="portal"
              class="form-control input-sm"
              :nullable="true"
              placeholder="(all portals)"
              :options="portals.map(portal => ({value: portal.id, label: portal.attributes.name}))"
          />
        </div>
      </div>
    </div>

    <loading-spinner v-if="loading" :style="loadingSpinnerStyle"></loading-spinner>

    <div v-else class="panel-body">
      <div v-if="data.datasets.length">
        <MonthlyChart
            :year="year"
            :granularity="granularity"
            :target-metric="targetMetric"
            :dataset="dataset"
            :data="data"
            :loading="loading"
            :portal="portal"
        />

        <div v-if="expanded">
          <hr>

          <MonthlyTable
              :year="year"
              :granularity="granularity"
              :target-metric="targetMetric"
              :dataset="dataset"
              :data="data"
          />
        </div>
      </div>

      <div v-else class="text-center text-muted" style="margin: 22px 0">
        There is no data to display!
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import SaveHeight from '@/mixins/SaveHeight'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'
import MonthlyChart from './MonthlyChart'
import MonthlyTable from './MonthlyTable'
import SelectWidget from '@/vendor/forms/FormGroups/Widgets/Select'

export default {
  components: {LoadingSpinner, MonthlyChart,MonthlyTable, SelectWidget},

  mixins: [SaveHeight],

  props: {
    year: {
      required: true,
    },

    targetMetric: {
      required: true
    }
  },

  data() {
    return {
      loading: true,
      expanded: true,

      data: null,
      portals: null,

      granularity: 'months',
      portal: null,
      dataset: null,
    }
  },

  mounted() {
    this.load()
  },

  watch: {
    year() {
      this.loadData()
    },

    granularity() {
      this.loadData()
    },

    portal() {
      this.loadData()
    }
  },

  methods: {
    load() {
      Promise.all([
        http.post('/api/v1/reports/trended-channel-types', {
          year: this.year,
          granularity: this.granularity,
          portal_id: this.portal,
        }),
          http.get('/api/v2/portals')
      ]).then(responses=> {
        this.data = responses[0].data.data

        this.portals = responses[1].data.data

        this.loading = false
      })
    },

    loadData() {
      this.saveHeight()

      this.loading = true

      http.post('/api/v1/reports/trended-channel-types', {
        year: this.year,
        granularity: this.granularity,
        portal_id: this.portal,
      }).then(response => {
        this.data = response.data.data

        this.loading = false
      })
    }
  }
}
</script>
